import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import checkoutSettingsReducer from './checkoutSettings/data/reducer';
import checkoutSettingsSaga, {
  initSaga as checkoutSettingsInitSaga,
} from './checkoutSettings/data/sagas';
import customerFacingNotesReducer from './customerFacingNotes/data/reducer';
import customerFacingNotesSaga, {
  initSaga as customerFacingNotesInitSaga,
} from './customerFacingNotes/data/sagas';
import emailTemplatesReducer from './emailTemplates/data/reducer';
import emailTemplatesSaga, {
  initSaga as emailTemplatesInitSaga,
} from './emailTemplates/data/sagas';
import expediteSettingsReducer from './expediteSettings/data/reducer';
import expediteSettingsSaga, {
  initSaga as expediteSettingsInitSaga,
} from './expediteSettings/data/sagas';
import internalNotesReducer from './internalNotes/data/reducer';
import internalNotesSaga from './internalNotes/data/sagas';
import leadTimeSettingsReducer from './leadTimeSettings/data/reducer';
import leadTimeSettingsSaga from './leadTimeSettings/data/sagas';
import manufacturerNotesReducer from './manufacturerNotes/data/reducer';
import manufacturerNotesSaga, {
  initSaga as manufacturerNotesInitSaga,
} from './manufacturerNotes/data/sagas';
import termsAndConditionsReducer from './termsAndConditions/data/reducer';
import termsAndConditionsSaga, {
  initSaga as termsAndConditionsInitSaga,
} from './termsAndConditions/data/sagas';

const initSaga = function* () {
  yield all([
    checkoutSettingsInitSaga(),
    emailTemplatesInitSaga(),
    expediteSettingsInitSaga(),
    manufacturerNotesInitSaga(),
    customerFacingNotesInitSaga(),
    termsAndConditionsInitSaga(),
  ]);
};

const reducer = combineReducers({
  checkoutSettings: checkoutSettingsReducer,
  emailTemplates: emailTemplatesReducer,
  expedites: expediteSettingsReducer,
  internalNotes: internalNotesReducer,
  leadTimes: leadTimeSettingsReducer,
  manufacturerNotes: manufacturerNotesReducer,
  quoteNotes: customerFacingNotesReducer,
  termsAndConditions: termsAndConditionsReducer,
});

const saga = function* () {
  yield all([
    checkoutSettingsSaga(),
    emailTemplatesSaga(),
    expediteSettingsSaga(),
    internalNotesSaga(),
    leadTimeSettingsSaga(),
    manufacturerNotesSaga(),
    customerFacingNotesSaga(),
    termsAndConditionsSaga(),
  ]);
};

export { initSaga, reducer, saga };
